<template>
  <div class="add-entry card">
    <photo v-if="photo && photo!==null && photo.folderName!==null" :photo="photo"/>
    <div class="card-body">
      <h4 class="card-title">{{entry.title ? entry.title : '...Project title'}}</h4>
      <ul>
        <li v-for="photo in entry.photos" :key="photo.pid">{{photo.fileName}}</li>
      </ul>
      <router-link
        v-if="entry.eid"
        :to="{ name: 'admin-update-entry', params: { eid: entry.eid, uid: uid, name: name } }"
        class="btn btn-outline-primary mr-1"
      >Edit</router-link>
      <router-link
        v-if="entry.eid"
        :to="{ name: 'admin-show-entry', params: { eid: entry.eid, uid: uid, name: name   } }"
        class="btn btn-outline-primary"
      >View</router-link>
      <delete-entry-link v-if="entry.complete==false" :eid="entry.eid" :uid="uid"/>
      <div class="progress-feedback" v-if="entry.complete==true">
        <span>Finalised.</span>
      </div>
      <div class="progress-feedback" v-if="entry.complete==false">
        <span>In Progress.</span> Please complete your entry and finalise your submission.
      </div>
    </div>
    <!--.card-text -->
  </div>

  <!--.card -->
  <!--.col -->
</template>

<script>
// import _ from 'lodash/core'
import DeleteEntryLink from '@/components/DeleteEntryLink.vue'
import Photo from '@/components/Photo.vue'
export default {
  data() {
    return {
      photo: null
    }
  },
  computed: {
    // phirstPhoto: () => this.$store.getters.photo.phirstPhoto
  },
  props: ['entry', 'photos', 'uid', 'name'],
  components: { DeleteEntryLink, Photo },
  methods: {
    entryImage() {
      //  console.log(this.entry.photos[0])
      // console.log(this.entry.photos[Object.keys(this.entry.photos)[0]])
      // this.photo = this.entry.photos[Object.keys(this.entry.photos)[0]]
    }
  },
  mounted() {
    this.photo = this.photos[Object.keys(this.photos)[0]]
    // this.entryImage()
  }
}
</script>

<style scoped>
.card-title {
  font-weight: 200;
  line-height: 1.2;
}
.progress-feedback {
  font-size: 80%;
  font-weight: 200;
  color: #6c757d !important;
  margin-top: 0.5em;
}

.progress-feedback span {
  font-weight: 600;
}
</style>
